import React from 'react';
import StatusBadge from './status-badge.component';

const ResultsTable = ({ results, getStatusLabel }) => {
  const headers = [
    { key: 'status', label: 'Status' },
    { key: 'firmName', label: 'Firm name' },
    { key: 'postcode', label: 'Postcode' },
    { key: 'address', label: 'Address' }
  ];

  return (
    <div className="results-table">
      <table className="results-table__desktop">
        <thead>
          <tr>
            {headers.map(header => (
              <th key={header.key}>{header.label}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {results.map((result, index) => (
            <tr key={index}>
              <td>
                <StatusBadge status={result.status} />
              </td>
              <td>{result.firmName}</td>
              <td>{result.postcode}</td>
              <td>{result.address}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="results-table__mobile">
        {results.map((result, index) => (
          <div key={index} className="results-table__card">
            <div className="results-table__row">
              <div className="results-table__label">Status</div>
              <div className="results-table__value">
                <StatusBadge status={result.status} />
              </div>
            </div>
            <div className="results-table__row">
              <div className="results-table__label">Firm name</div>
              <div className="results-table__value">{result.firmName}</div>
            </div>
            <div className="results-table__row">
              <div className="results-table__label">Postcode</div>
              <div className="results-table__value">{result.postcode}</div>
            </div>
            <div className="results-table__row">
              <div className="results-table__label">Address</div>
              <div className="results-table__value">{result.address}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ResultsTable;
